var map = {
	"./": 72812,
	"./App": 19349,
	"./App.css": 44050,
	"./App.js": 19349,
	"./App.module.sass": 68242,
	"./app-core/AppContext": 14088,
	"./app-core/AppContext.js": 14088,
	"./components/AdaptiveLogo/AdaptiveLogo": 15782,
	"./components/AdaptiveLogo/AdaptiveLogo.jsx": 15782,
	"./components/AdaptiveLogo/AdaptiveLogo.module.sass": 98673,
	"./components/AdaptiveLogo/imageTone": 91194,
	"./components/AdaptiveLogo/imageTone.js": 91194,
	"./components/AddLanguageModal": 19996,
	"./components/AddLanguageModal/": 19996,
	"./components/AddLanguageModal/AddLanguageModal": 2688,
	"./components/AddLanguageModal/AddLanguageModal.jsx": 2688,
	"./components/AddLanguageModal/AddLanguageModal.module.sass": 89343,
	"./components/AddLanguageModal/index": 19996,
	"./components/AddLanguageModal/index.js": 19996,
	"./components/AdminPanel/AdminPanel": 94049,
	"./components/AdminPanel/AdminPanel.jsx": 94049,
	"./components/AdminPanel/AdminPanel.module.sass": 18933,
	"./components/AdminPanel/ConfigPicker": 92663,
	"./components/AdminPanel/ConfigPicker.jsx": 92663,
	"./components/AdminPanel/ConfigPicker.module.sass": 15352,
	"./components/BrokerProgram/BrokerProgram": 43050,
	"./components/BrokerProgram/BrokerProgram.jsx": 43050,
	"./components/BrokerProgram/BrokerProgram.module.sass": 58485,
	"./components/BrokerProgram/FintechSuccessModal": 98688,
	"./components/BrokerProgram/FintechSuccessModal.jsx": 98688,
	"./components/BrokerProgram/TransactionCard": 39749,
	"./components/BrokerProgram/TransactionCard.jsx": 39749,
	"./components/Chat/Chat": 98281,
	"./components/Chat/Chat.jsx": 98281,
	"./components/Chat/Chat.module.sass": 47863,
	"./components/ConfirmDialog/ConfirmDialog": 40998,
	"./components/ConfirmDialog/ConfirmDialog.jsx": 40998,
	"./components/ConfirmDialog/ConfirmDialog.module.sass": 42705,
	"./components/CryptoChart/CryptoChart": 2514,
	"./components/CryptoChart/CryptoChart.jsx": 2514,
	"./components/CryptoChart/CryptoChart.module.sass": 35285,
	"./components/Dashbroad": 92185,
	"./components/Dashbroad.jsx": 92185,
	"./components/Dashbroad.module.sass": 59856,
	"./components/FlagIcon/FlagIcon": 80562,
	"./components/FlagIcon/FlagIcon.jsx": 80562,
	"./components/GradientLineChart": 25959,
	"./components/GradientLineChart.js": 25959,
	"./components/Header/Header": 62779,
	"./components/Header/Header.jsx": 62779,
	"./components/Header/Header.module.sass": 61221,
	"./components/LoginScreen/LoginScreen": 78494,
	"./components/LoginScreen/LoginScreen.jsx": 78494,
	"./components/LoginScreen/LoginScreen.module.sass": 65545,
	"./components/Mailbox/Mailbox": 73886,
	"./components/Mailbox/Mailbox.jsx": 73886,
	"./components/Mailbox/Mailbox.module.sass": 79753,
	"./components/MiniFigma": 25227,
	"./components/MiniFigma/": 25227,
	"./components/MiniFigma/MiniFigma": 78006,
	"./components/MiniFigma/MiniFigma.jsx": 78006,
	"./components/MiniFigma/MiniFigma.module.sass": 79289,
	"./components/MiniFigma/index": 25227,
	"./components/MiniFigma/index.js": 25227,
	"./components/NavBar/NavBar": 71165,
	"./components/NavBar/NavBar.jsx": 71165,
	"./components/NavBar/NavBar.module.sass": 19231,
	"./components/OrderBook/OrderBook": 34918,
	"./components/OrderBook/OrderBook.jsx": 34918,
	"./components/OrderBook/OrderBook.module.sass": 21009,
	"./components/ProgressBar/ProgressBar": 22822,
	"./components/ProgressBar/ProgressBar.jsx": 22822,
	"./components/ProgressBar/ProgressBar.module.sass": 97953,
	"./components/Settings/SecondPart": 23270,
	"./components/Settings/SecondPart.js": 23270,
	"./components/Settings/Settings": 79062,
	"./components/Settings/Settings.jsx": 79062,
	"./components/Settings/Settings.module.sass": 92617,
	"./components/SettingsPage": 60392,
	"./components/SettingsPage/": 60392,
	"./components/SettingsPage/SettingsPage": 67888,
	"./components/SettingsPage/SettingsPage.jsx": 67888,
	"./components/SettingsPage/SettingsPage.module.sass": 59183,
	"./components/SettingsPage/_novaTokens.sass": 92489,
	"./components/SettingsPage/index": 60392,
	"./components/SettingsPage/index.js": 60392,
	"./components/SettingsPage/tabs/AuditLogsTab": 99030,
	"./components/SettingsPage/tabs/AuditLogsTab.jsx": 99030,
	"./components/SettingsPage/tabs/AuditLogsTab.module.sass": 91737,
	"./components/SettingsPage/tabs/MailTab": 25997,
	"./components/SettingsPage/tabs/MailTab.jsx": 25997,
	"./components/SettingsPage/tabs/MailTab.module.sass": 39158,
	"./components/SettingsPage/tabs/ModalStepsTab": 41350,
	"./components/SettingsPage/tabs/ModalStepsTab.jsx": 41350,
	"./components/SettingsPage/tabs/ModalStepsTab.module.sass": 39729,
	"./components/SettingsPage/tabs/SapsTab": 5827,
	"./components/SettingsPage/tabs/SapsTab.jsx": 5827,
	"./components/SettingsPage/tabs/SapsTab.module.sass": 3380,
	"./components/SettingsPage/tabs/SentEmailsTab": 34369,
	"./components/SettingsPage/tabs/SentEmailsTab.jsx": 34369,
	"./components/SettingsPage/tabs/SentEmailsTab.module.sass": 17350,
	"./components/SettingsPage/tabs/UserStats": 48579,
	"./components/SettingsPage/tabs/UserStats.jsx": 48579,
	"./components/SettingsPage/tabs/UserStats.module.sass": 52938,
	"./components/SettingsPage/tabs/UsersTab": 18794,
	"./components/SettingsPage/tabs/UsersTab.jsx": 18794,
	"./components/SettingsPage/tabs/UsersTab.module.sass": 24773,
	"./components/SiteSettings/SiteSettings": 23032,
	"./components/SiteSettings/SiteSettings.jsx": 23032,
	"./components/SiteSettings/SiteSettings.jsx.backup": 79689,
	"./components/SiteSettings/SiteSettings.jsx.bak": 50187,
	"./components/SiteSettings/SiteSettings.jsx.broken": 73292,
	"./components/SiteSettings/SiteSettings.module.sass": 44263,
	"./components/Toast": 88369,
	"./components/Toast/": 88369,
	"./components/Toast/Toast": 88234,
	"./components/Toast/Toast.jsx": 88234,
	"./components/Toast/Toast.module.sass": 74221,
	"./components/Toast/index": 88369,
	"./components/Toast/index.js": 88369,
	"./components/ToggleSwitch/ToggleSwitch": 53404,
	"./components/ToggleSwitch/ToggleSwitch.jsx": 53404,
	"./components/ToggleSwitch/ToggleSwitch.module.sass": 47043,
	"./components/TradingDashboard/TradingDashboard": 53154,
	"./components/TradingDashboard/TradingDashboard.jsx": 53154,
	"./components/TradingDashboard/TradingDashboard.module.sass": 3397,
	"./components/TransactionTable/TransactionTable": 49236,
	"./components/TransactionTable/TransactionTable.jsx": 49236,
	"./components/TransactionTable/TransactionTable.module.sass": 54683,
	"./components/Wallet/Button": 97329,
	"./components/Wallet/Button.jsx": 97329,
	"./components/Wallet/Wallet": 44178,
	"./components/Wallet/Wallet.jsx": 44178,
	"./components/Wallet/Wallet.module.sass": 28277,
	"./config/api": 24227,
	"./config/api.js": 24227,
	"./config/defaultSettings": 30828,
	"./config/defaultSettings.json": 30828,
	"./config/flags": 4396,
	"./config/flags.js": 4396,
	"./config/languages": 3716,
	"./config/languages.js": 3716,
	"./hooks": 61139,
	"./hooks/": 61139,
	"./hooks/index": 61139,
	"./hooks/index.js": 61139,
	"./hooks/useToast": 72725,
	"./hooks/useToast.js": 72725,
	"./hooks/useTranslation": 91685,
	"./hooks/useTranslation.js": 91685,
	"./img/Bitcoin.svg.png": 47532,
	"./img/Ethereum-ETH-icon.png": 6675,
	"./img/Graphic.png": 84202,
	"./img/ICBC.png": 42533,
	"./img/about.png": 67569,
	"./img/add.png": 34567,
	"./img/android.png": 10335,
	"./img/apple.png": 93974,
	"./img/arg.png": 33254,
	"./img/arg.svg": 99804,
	"./img/arrow.svg": 30195,
	"./img/assetdistribution.png": 66132,
	"./img/astropay.png": 72530,
	"./img/bank.png": 22926,
	"./img/bankicons/AmBank.png": 19735,
	"./img/bankicons/Bank of Singapore.png": 68812,
	"./img/bankicons/Bank_Rakyat_Malaysia.png": 410,
	"./img/bankicons/BigPay.png": 19995,
	"./img/bankicons/Boost.png": 34250,
	"./img/bankicons/CIMB_Group.png": 19434,
	"./img/bankicons/Citibank Singapore.png": 25218,
	"./img/bankicons/DBS Bank.png": 72874,
	"./img/bankicons/DBS PayLah.png": 34093,
	"./img/bankicons/EZ-Link Wallet (SimplyGo).png": 78009,
	"./img/bankicons/FavePay.png": 61353,
	"./img/bankicons/GoPayz.png": 32825,
	"./img/bankicons/GrabPay.png": 11671,
	"./img/bankicons/HSBC Singapore.png": 90023,
	"./img/bankicons/HSBC_Malaysia.png": 95247,
	"./img/bankicons/HongLeongBank.png": 77022,
	"./img/bankicons/ICBC.png": 26150,
	"./img/bankicons/Instapay_eWallet.png": 25841,
	"./img/bankicons/Instarem (Nium).png": 75028,
	"./img/bankicons/MAE_by_Maybank2u.png": 65645,
	"./img/bankicons/Maybank Singapore.png": 73364,
	"./img/bankicons/Maybank.png": 41714,
	"./img/bankicons/OCBC_Bank_Malaysia.png": 96649,
	"./img/bankicons/POSB.png": 96187,
	"./img/bankicons/Public_Bank_Berhad.png": 32778,
	"./img/bankicons/RHB_Bank.png": 21510,
	"./img/bankicons/Revolut.png": 37654,
	"./img/bankicons/ShopeePay.png": 22695,
	"./img/bankicons/Standard Chartered Singapore.png": 89236,
	"./img/bankicons/Touch_n_Go_eWallet.png": 13835,
	"./img/bankicons/Trust Bank.png": 26883,
	"./img/bankicons/UOB_Malaysia.png": 51471,
	"./img/bankicons/Wise_TransferWise.png": 76641,
	"./img/bankicons/YouTrip.png": 57567,
	"./img/bankicons/alliance.png": 65576,
	"./img/bankicons/astropay.png": 95318,
	"./img/bankicons/bbva.png": 7676,
	"./img/bankicons/belo.png": 82387,
	"./img/bankicons/bna.png": 11658,
	"./img/bankicons/brubank.png": 71424,
	"./img/bankicons/ciudad.png": 29855,
	"./img/bankicons/credicoop.png": 80349,
	"./img/bankicons/cuentadni.png": 16404,
	"./img/bankicons/default-bank.png": 45729,
	"./img/bankicons/fiwind.png": 95082,
	"./img/bankicons/galicia.png": 65297,
	"./img/bankicons/gxbank.png": 27276,
	"./img/bankicons/lemon.png": 61458,
	"./img/bankicons/macro.png": 4823,
	"./img/bankicons/mastercard.png": 57967,
	"./img/bankicons/mercadopago.png": 10563,
	"./img/bankicons/naranja.png": 74738,
	"./img/bankicons/otrobanco.png": 42926,
	"./img/bankicons/pampa.png": 99508,
	"./img/bankicons/patagonia.png": 20853,
	"./img/bankicons/personalpay.png": 95849,
	"./img/bankicons/prex.png": 88490,
	"./img/bankicons/provincia.png": 76166,
	"./img/bankicons/santander.png": 75227,
	"./img/bankicons/supervielle.png": 16291,
	"./img/bankicons/uala.png": 6352,
	"./img/bankicons/visa.png": 87860,
	"./img/banksign-green.png": 81199,
	"./img/banksign.png": 67949,
	"./img/barchart-svgrepo-com.svg": 21512,
	"./img/bbva.png": 51435,
	"./img/bell-svgrepo-com.svg": 6046,
	"./img/belo.png": 7200,
	"./img/binance-coin-bnb-logo-CD94CC6D31-seeklogo.com.png": 32705,
	"./img/bna.png": 19979,
	"./img/broker-program-normal.svg": 86656,
	"./img/brokercenter.png": 79620,
	"./img/brubank.png": 97801,
	"./img/buy.png": 32138,
	"./img/buy.webp": 58588,
	"./img/calendarik.png": 24346,
	"./img/ciudad.png": 38828,
	"./img/clock.svg": 23954,
	"./img/coms.png": 67766,
	"./img/convert.png": 39507,
	"./img/credicoop.png": 41964,
	"./img/cuentadni.png": 2137,
	"./img/dashboard-normal.svg": 54180,
	"./img/defi.png": 46534,
	"./img/diagram-essential-web-svgrepo-com.svg": 96848,
	"./img/done-ring-round-svgrepo-com.svg": 9277,
	"./img/enviado24h.png": 80554,
	"./img/enviar.png": 47571,
	"./img/envvv1.png": 59306,
	"./img/envvv2.png": 16737,
	"./img/envvv3.png": 79256,
	"./img/eurosign.png": 536,
	"./img/exit-normal.svg": 70416,
	"./img/filter.png": 50934,
	"./img/fiwind.png": 16721,
	"./img/flagicons/ad.svg": 20764,
	"./img/flagicons/ae.svg": 32957,
	"./img/flagicons/af.svg": 86686,
	"./img/flagicons/ag.svg": 6735,
	"./img/flagicons/ai.svg": 3481,
	"./img/flagicons/al.svg": 45300,
	"./img/flagicons/am.svg": 66933,
	"./img/flagicons/ao.svg": 93511,
	"./img/flagicons/aq.svg": 3569,
	"./img/flagicons/ar.svg": 46466,
	"./img/flagicons/arab.svg": 32415,
	"./img/flagicons/as.svg": 50195,
	"./img/flagicons/asean.svg": 99281,
	"./img/flagicons/at.svg": 27628,
	"./img/flagicons/au.svg": 74989,
	"./img/flagicons/aw.svg": 6655,
	"./img/flagicons/ax.svg": 96440,
	"./img/flagicons/az.svg": 76986,
	"./img/flagicons/ba.svg": 16344,
	"./img/flagicons/bb.svg": 55179,
	"./img/flagicons/bd.svg": 68485,
	"./img/flagicons/be.svg": 90468,
	"./img/flagicons/bf.svg": 95063,
	"./img/flagicons/bg.svg": 48614,
	"./img/flagicons/bh.svg": 46769,
	"./img/flagicons/bi.svg": 89856,
	"./img/flagicons/bj.svg": 80595,
	"./img/flagicons/bl.svg": 75661,
	"./img/flagicons/bm.svg": 40204,
	"./img/flagicons/bn.svg": 2879,
	"./img/flagicons/bo.svg": 64942,
	"./img/flagicons/bq.svg": 68488,
	"./img/flagicons/br.svg": 49851,
	"./img/flagicons/bs.svg": 7882,
	"./img/flagicons/bt.svg": 63157,
	"./img/flagicons/bv.svg": 89735,
	"./img/flagicons/bw.svg": 50198,
	"./img/flagicons/by.svg": 9168,
	"./img/flagicons/bz.svg": 75267,
	"./img/flagicons/ca.svg": 7151,
	"./img/flagicons/cc.svg": 17597,
	"./img/flagicons/cd.svg": 83666,
	"./img/flagicons/cefta.svg": 7066,
	"./img/flagicons/cf.svg": 57616,
	"./img/flagicons/cg.svg": 93153,
	"./img/flagicons/ch.svg": 65910,
	"./img/flagicons/ci.svg": 29735,
	"./img/flagicons/ck.svg": 54133,
	"./img/flagicons/cl.svg": 30922,
	"./img/flagicons/cm.svg": 91291,
	"./img/flagicons/cn.svg": 56904,
	"./img/flagicons/co.svg": 22297,
	"./img/flagicons/cp.svg": 36686,
	"./img/flagicons/cr.svg": 86092,
	"./img/flagicons/cu.svg": 19987,
	"./img/flagicons/cv.svg": 99232,
	"./img/flagicons/cw.svg": 18833,
	"./img/flagicons/cx.svg": 37030,
	"./img/flagicons/cy.svg": 35063,
	"./img/flagicons/cz.svg": 8292,
	"./img/flagicons/de.svg": 78234,
	"./img/flagicons/dg.svg": 58456,
	"./img/flagicons/dj.svg": 69357,
	"./img/flagicons/dk.svg": 89644,
	"./img/flagicons/dm.svg": 94690,
	"./img/flagicons/do.svg": 2784,
	"./img/flagicons/dz.svg": 94973,
	"./img/flagicons/eac.svg": 53516,
	"./img/flagicons/ec.svg": 37319,
	"./img/flagicons/ee.svg": 81465,
	"./img/flagicons/eg.svg": 97435,
	"./img/flagicons/eh.svg": 95196,
	"./img/flagicons/er.svg": 96198,
	"./img/flagicons/es-ct.svg": 53301,
	"./img/flagicons/es-ga.svg": 3580,
	"./img/flagicons/es-pv.svg": 91134,
	"./img/flagicons/es.svg": 42647,
	"./img/flagicons/et.svg": 63928,
	"./img/flagicons/eu.svg": 23081,
	"./img/flagicons/fi.svg": 35636,
	"./img/flagicons/fj.svg": 83847,
	"./img/flagicons/fk.svg": 36982,
	"./img/flagicons/fm.svg": 81448,
	"./img/flagicons/fo.svg": 44522,
	"./img/flagicons/fr.svg": 96991,
	"./img/flagicons/ga.svg": 92947,
	"./img/flagicons/gb-eng.svg": 63543,
	"./img/flagicons/gb-nir.svg": 93580,
	"./img/flagicons/gb-sct.svg": 43721,
	"./img/flagicons/gb-wls.svg": 50575,
	"./img/flagicons/gb.svg": 48288,
	"./img/flagicons/gd.svg": 34766,
	"./img/flagicons/ge.svg": 49407,
	"./img/flagicons/gf.svg": 86732,
	"./img/flagicons/gg.svg": 17741,
	"./img/flagicons/gh.svg": 19738,
	"./img/flagicons/gi.svg": 97259,
	"./img/flagicons/gl.svg": 95142,
	"./img/flagicons/gm.svg": 84119,
	"./img/flagicons/gn.svg": 29668,
	"./img/flagicons/gp.svg": 41778,
	"./img/flagicons/gq.svg": 45091,
	"./img/flagicons/gr.svg": 55696,
	"./img/flagicons/gs.svg": 46817,
	"./img/flagicons/gt.svg": 29438,
	"./img/flagicons/gu.svg": 65839,
	"./img/flagicons/gw.svg": 75709,
	"./img/flagicons/gy.svg": 49403,
	"./img/flagicons/hk.svg": 47952,
	"./img/flagicons/hm.svg": 70110,
	"./img/flagicons/hn.svg": 7933,
	"./img/flagicons/hr.svg": 40457,
	"./img/flagicons/ht.svg": 25399,
	"./img/flagicons/hu.svg": 27366,
	"./img/flagicons/ic.svg": 39371,
	"./img/flagicons/id.svg": 51044,
	"./img/flagicons/ie.svg": 2213,
	"./img/flagicons/il.svg": 28844,
	"./img/flagicons/im.svg": 11437,
	"./img/flagicons/in.svg": 79438,
	"./img/flagicons/io.svg": 13900,
	"./img/flagicons/iq.svg": 65049,
	"./img/flagicons/ir.svg": 73674,
	"./img/flagicons/is.svg": 34043,
	"./img/flagicons/it.svg": 24276,
	"./img/flagicons/je.svg": 32396,
	"./img/flagicons/jm.svg": 77892,
	"./img/flagicons/jo.svg": 33478,
	"./img/flagicons/jp.svg": 8833,
	"./img/flagicons/ke.svg": 45515,
	"./img/flagicons/kg.svg": 65833,
	"./img/flagicons/kh.svg": 55278,
	"./img/flagicons/ki.svg": 93215,
	"./img/flagicons/km.svg": 70931,
	"./img/flagicons/kn.svg": 80192,
	"./img/flagicons/kp.svg": 40534,
	"./img/flagicons/kr.svg": 8564,
	"./img/flagicons/kw.svg": 24217,
	"./img/flagicons/ky.svg": 16975,
	"./img/flagicons/kz.svg": 37948,
	"./img/flagicons/la.svg": 25102,
	"./img/flagicons/lb.svg": 8077,
	"./img/flagicons/lc.svg": 77068,
	"./img/flagicons/li.svg": 85478,
	"./img/flagicons/lk.svg": 20004,
	"./img/flagicons/lr.svg": 66045,
	"./img/flagicons/ls.svg": 53852,
	"./img/flagicons/lt.svg": 35427,
	"./img/flagicons/lu.svg": 32114,
	"./img/flagicons/lv.svg": 37153,
	"./img/flagicons/ly.svg": 79734,
	"./img/flagicons/ma.svg": 85309,
	"./img/flagicons/mc.svg": 93711,
	"./img/flagicons/md.svg": 44176,
	"./img/flagicons/me.svg": 56417,
	"./img/flagicons/mf.svg": 51378,
	"./img/flagicons/mg.svg": 89315,
	"./img/flagicons/mh.svg": 32884,
	"./img/flagicons/mk.svg": 20743,
	"./img/flagicons/ml.svg": 936,
	"./img/flagicons/mm.svg": 8857,
	"./img/flagicons/mn.svg": 64458,
	"./img/flagicons/mo.svg": 82299,
	"./img/flagicons/mp.svg": 79980,
	"./img/flagicons/mq.svg": 59693,
	"./img/flagicons/mr.svg": 30574,
	"./img/flagicons/ms.svg": 35327,
	"./img/flagicons/mt.svg": 93120,
	"./img/flagicons/mu.svg": 55921,
	"./img/flagicons/mv.svg": 85026,
	"./img/flagicons/mw.svg": 64019,
	"./img/flagicons/mx.svg": 25476,
	"./img/flagicons/my.svg": 80197,
	"./img/flagicons/mz.svg": 81062,
	"./img/flagicons/na.svg": 41380,
	"./img/flagicons/nc.svg": 70118,
	"./img/flagicons/ne.svg": 95320,
	"./img/flagicons/nf.svg": 29707,
	"./img/flagicons/ng.svg": 15098,
	"./img/flagicons/ni.svg": 19180,
	"./img/flagicons/nl.svg": 51921,
	"./img/flagicons/no.svg": 31554,
	"./img/flagicons/np.svg": 87221,
	"./img/flagicons/nr.svg": 62823,
	"./img/flagicons/nu.svg": 89992,
	"./img/flagicons/nz.svg": 40239,
	"./img/flagicons/om.svg": 87407,
	"./img/flagicons/pa.svg": 37618,
	"./img/flagicons/pc.svg": 30416,
	"./img/flagicons/pe.svg": 17374,
	"./img/flagicons/pf.svg": 71549,
	"./img/flagicons/pg.svg": 924,
	"./img/flagicons/ph.svg": 68539,
	"./img/flagicons/pk.svg": 87176,
	"./img/flagicons/pl.svg": 6983,
	"./img/flagicons/pm.svg": 19862,
	"./img/flagicons/pn.svg": 61109,
	"./img/flagicons/pr.svg": 42161,
	"./img/flagicons/ps.svg": 79360,
	"./img/flagicons/pt.svg": 21567,
	"./img/flagicons/pw.svg": 66220,
	"./img/flagicons/py.svg": 54810,
	"./img/flagicons/qa.svg": 94577,
	"./img/flagicons/re.svg": 12212,
	"./img/flagicons/ro.svg": 53598,
	"./img/flagicons/rs.svg": 43898,
	"./img/flagicons/ru.svg": 53828,
	"./img/flagicons/rw.svg": 19302,
	"./img/flagicons/sa.svg": 25983,
	"./img/flagicons/sb.svg": 46956,
	"./img/flagicons/sc.svg": 94317,
	"./img/flagicons/sd.svg": 65794,
	"./img/flagicons/se.svg": 69523,
	"./img/flagicons/sg.svg": 22897,
	"./img/flagicons/sh-ac.svg": 80983,
	"./img/flagicons/sh-hl.svg": 6395,
	"./img/flagicons/sh-ta.svg": 46850,
	"./img/flagicons/sh.svg": 71718,
	"./img/flagicons/si.svg": 60695,
	"./img/flagicons/sj.svg": 6244,
	"./img/flagicons/sk.svg": 3493,
	"./img/flagicons/sl.svg": 96314,
	"./img/flagicons/sm.svg": 73835,
	"./img/flagicons/sn.svg": 15768,
	"./img/flagicons/so.svg": 41129,
	"./img/flagicons/sr.svg": 40092,
	"./img/flagicons/ss.svg": 52285,
	"./img/flagicons/st.svg": 18354,
	"./img/flagicons/sv.svg": 32272,
	"./img/flagicons/sx.svg": 65974,
	"./img/flagicons/sy.svg": 12839,
	"./img/flagicons/sz.svg": 64628,
	"./img/flagicons/tc.svg": 48436,
	"./img/flagicons/td.svg": 58203,
	"./img/flagicons/tf.svg": 89209,
	"./img/flagicons/tg.svg": 7464,
	"./img/flagicons/th.svg": 74063,
	"./img/flagicons/tj.svg": 84509,
	"./img/flagicons/tk.svg": 95036,
	"./img/flagicons/tl.svg": 65219,
	"./img/flagicons/tm.svg": 50578,
	"./img/flagicons/tn.svg": 43713,
	"./img/flagicons/to.svg": 8176,
	"./img/flagicons/tr.svg": 26373,
	"./img/flagicons/tt.svg": 63531,
	"./img/flagicons/tv.svg": 17033,
	"./img/flagicons/tw.svg": 29144,
	"./img/flagicons/tz.svg": 35597,
	"./img/flagicons/ua.svg": 78789,
	"./img/flagicons/ug.svg": 15947,
	"./img/flagicons/um.svg": 38161,
	"./img/flagicons/un.svg": 17794,
	"./img/flagicons/unknown.svg": 37735,
	"./img/flagicons/us.svg": 49063,
	"./img/flagicons/uy.svg": 36925,
	"./img/flagicons/uz.svg": 99102,
	"./img/flagicons/va.svg": 8972,
	"./img/flagicons/vc.svg": 59566,
	"./img/flagicons/ve.svg": 22112,
	"./img/flagicons/vg.svg": 14018,
	"./img/flagicons/vi.svg": 54468,
	"./img/flagicons/vn.svg": 16619,
	"./img/flagicons/vu.svg": 73168,
	"./img/flagicons/wf.svg": 14524,
	"./img/flagicons/ws.svg": 13681,
	"./img/flagicons/xk.svg": 15200,
	"./img/flagicons/xx.svg": 12003,
	"./img/flagicons/ye.svg": 51445,
	"./img/flagicons/yt.svg": 2052,
	"./img/flagicons/za.svg": 67280,
	"./img/flagicons/zm.svg": 91188,
	"./img/flagicons/zw.svg": 23969,
	"./img/galicia.png": 2184,
	"./img/gamepad.png": 28795,
	"./img/greenmark.png": 53788,
	"./img/hidden-icon.png": 24836,
	"./img/iconsas/1.png": 6872,
	"./img/iconsas/1tarif.png": 31766,
	"./img/iconsas/2.png": 81363,
	"./img/iconsas/2tarif.png": 52711,
	"./img/iconsas/3tarif.png": 59892,
	"./img/iconsas/4tarif.png": 37605,
	"./img/iconsas/add_button.png": 89981,
	"./img/iconsas/additional_sum.png": 63306,
	"./img/iconsas/bank_configuration.png": 70596,
	"./img/iconsas/bank_conversion_modal.png": 56722,
	"./img/iconsas/comission_modal.png": 21339,
	"./img/iconsas/comission_size.png": 96817,
	"./img/iconsas/crypto_conversion_modal.png": 51993,
	"./img/iconsas/currency_rates.png": 45528,
	"./img/iconsas/currency_symbol.png": 94925,
	"./img/iconsas/custom_values.png": 13331,
	"./img/iconsas/deposut_sum.png": 30099,
	"./img/iconsas/export_button.png": 42272,
	"./img/iconsas/import_button.png": 3567,
	"./img/iconsas/name_user_and_chat_preset.png": 49087,
	"./img/iconsas/quickactions.png": 42207,
	"./img/iconsas/remove_button.png": 48754,
	"./img/iconsas/reset_settings_button.png": 75347,
	"./img/iconsas/save_button.png": 52935,
	"./img/iconsas/site_settings.png": 59206,
	"./img/iconsas/success_modal.png": 39886,
	"./img/iconsas/tarifs_settings.png": 60112,
	"./img/iconsas/tax_modal.png": 93268,
	"./img/iconsas/tax_percent.png": 54668,
	"./img/iconsas/timezone.png": 55136,
	"./img/iconsas/transactions.png": 79582,
	"./img/iconsas/user_information.png": 1339,
	"./img/iconsas/users_winnings.png": 68565,
	"./img/iconsas/verification_modal.png": 84694,
	"./img/iconsas/viptarif.png": 21898,
	"./img/iconsas/wallets.png": 9875,
	"./img/iconsas/znakov_posle_zapyatoi.png": 65984,
	"./img/irs-ieagle.png": 48450,
	"./img/irs-small1.png": 87155,
	"./img/irs-small2.png": 91544,
	"./img/irs-stamp.png": 87576,
	"./img/irs.png": 10202,
	"./img/irsbackgrounds/irs_en.png": 90666,
	"./img/irsbackgrounds/irs_es.png": 8767,
	"./img/key.png": 56183,
	"./img/lemon.png": 63451,
	"./img/logo.png": 62077,
	"./img/logo1.png": 32480,
	"./img/logo2.png": 71163,
	"./img/macro.png": 86026,
	"./img/mail.png": 46833,
	"./img/mailbox-normal.svg": 83192,
	"./img/markets-normal.svg": 21397,
	"./img/mastercard.png": 6236,
	"./img/mercadopago.png": 48762,
	"./img/message-circle-dots-svgrepo-com.svg": 84226,
	"./img/moneda.png": 93026,
	"./img/naranja.png": 18803,
	"./img/nastroiki.png": 87946,
	"./img/neighborhood-svgrepo-com.svg": 21097,
	"./img/options.png": 75844,
	"./img/ordercenter.png": 23549,
	"./img/otrobanco.png": 12479,
	"./img/paint.png": 44426,
	"./img/pampa.png": 81213,
	"./img/patagonia.png": 95668,
	"./img/person-line-drawing-plus-svgrepo-com.svg": 45073,
	"./img/person-png.png": 86517,
	"./img/person-svgrepo-com.svg": 74794,
	"./img/personalpay.png": 95520,
	"./img/phone.png": 61326,
	"./img/plusik.png": 45412,
	"./img/pnl.png": 31324,
	"./img/poisk.png": 68096,
	"./img/porreports.png": 74092,
	"./img/prex.png": 6325,
	"./img/provincia.png": 24571,
	"./img/qr.png": 79853,
	"./img/qr1.png": 76240,
	"./img/santander.png": 32290,
	"./img/search-svgrepo-com.svg": 68877,
	"./img/settings-normal.svg": 23457,
	"./img/settings-svgrepo-com.svg": 50114,
	"./img/settings.png": 26683,
	"./img/shield-check-fill-svgrepo-com.svg": 63467,
	"./img/solana.png": 8432,
	"./img/somelogo.png": 80001,
	"./img/sortirovka.png": 24838,
	"./img/squares-four-fill-svgrepo-com.svg": 47096,
	"./img/strelkaa.png": 94911,
	"./img/supervielle.png": 51342,
	"./img/support-chat-normal.svg": 37568,
	"./img/support.png": 35315,
	"./img/supportChat.png": 3817,
	"./img/telegram.webp": 46031,
	"./img/tg_image_3444736134.png": 27167,
	"./img/tg_image_3753232113.png": 83730,
	"./img/three-open-svgrepo-com.svg": 704,
	"./img/totalclientes.png": 6881,
	"./img/trade-normal.svg": 8434,
	"./img/trade.png": 79808,
	"./img/triangle-filled-svgrepo-com.svg": 18680,
	"./img/triangle-svgrepo-com.svg": 58357,
	"./img/tron.png": 85241,
	"./img/uala.png": 93807,
	"./img/usdclogo.png": 35298,
	"./img/user.png": 97477,
	"./img/verif.png": 15068,
	"./img/verif_shield.png": 96074,
	"./img/verified-svgrepo-com.svg": 56885,
	"./img/visa.png": 23643,
	"./img/visible-icon.png": 27420,
	"./img/voskl.svg": 85801,
	"./img/wallet-normal.svg": 97481,
	"./img/wallet-svgrepo-com.svg": 52922,
	"./img/walletincircle.jpg": 96558,
	"./img/windows.png": 72573,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./logo.svg": 69445,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./themes/nova/NovaApp": 7525,
	"./themes/nova/NovaApp.jsx": 7525,
	"./themes/nova/NovaApp.module.sass": 63778,
	"./themes/nova/NovaChart": 48284,
	"./themes/nova/NovaChart.jsx": 48284,
	"./themes/nova/NovaFigmaSheet": 10231,
	"./themes/nova/NovaFigmaSheet.jsx": 10231,
	"./themes/nova/NovaFigmaSheet.module.sass": 26792,
	"./themes/nova/NovaHeader": 15874,
	"./themes/nova/NovaHeader.jsx": 15874,
	"./themes/nova/NovaNav": 78220,
	"./themes/nova/NovaNav.jsx": 78220,
	"./themes/nova/NovaNews": 80930,
	"./themes/nova/NovaNews.jsx": 80930,
	"./themes/nova/NovaNews.module.sass": 71320,
	"./themes/nova/NovaThemeContext": 7210,
	"./themes/nova/NovaThemeContext.js": 7210,
	"./themes/nova/NovaTicker": 87748,
	"./themes/nova/NovaTicker.jsx": 87748,
	"./themes/nova/NovaTicker.module.sass": 75939,
	"./themes/nova/NovaTooltip": 27577,
	"./themes/nova/NovaTooltip.jsx": 27577,
	"./themes/nova/NovaTooltip.module.sass": 94310,
	"./themes/nova/NovaTrending": 65,
	"./themes/nova/NovaTrending.jsx": 65,
	"./themes/nova/NovaTrending.module.sass": 95646,
	"./themes/nova/captureScreen": 15724,
	"./themes/nova/captureScreen.js": 15724,
	"./themes/nova/components/BankLogo": 90254,
	"./themes/nova/components/BankLogo.jsx": 90254,
	"./themes/nova/modals/NovaBankConversionModal": 9508,
	"./themes/nova/modals/NovaBankConversionModal.jsx": 9508,
	"./themes/nova/modals/NovaCodeModal": 97843,
	"./themes/nova/modals/NovaCodeModal.jsx": 97843,
	"./themes/nova/modals/NovaCodeModal.module.sass": 62244,
	"./themes/nova/modals/NovaCommissionModal": 27711,
	"./themes/nova/modals/NovaCommissionModal.jsx": 27711,
	"./themes/nova/modals/NovaCommissionModal.module.sass": 79488,
	"./themes/nova/modals/NovaConversionModal": 76294,
	"./themes/nova/modals/NovaConversionModal.jsx": 76294,
	"./themes/nova/modals/NovaPremiumModal": 86839,
	"./themes/nova/modals/NovaPremiumModal.jsx": 86839,
	"./themes/nova/modals/NovaSuccessModal": 6529,
	"./themes/nova/modals/NovaSuccessModal.jsx": 6529,
	"./themes/nova/modals/NovaSuccessModal.module.sass": 75102,
	"./themes/nova/modals/NovaVerificationModal": 7745,
	"./themes/nova/modals/NovaVerificationModal.jsx": 7745,
	"./themes/nova/modals/modalKit": 52778,
	"./themes/nova/modals/modalKit.jsx": 52778,
	"./themes/nova/pages/NovaBroker": 35212,
	"./themes/nova/pages/NovaBroker.jsx": 35212,
	"./themes/nova/pages/NovaBroker.module.sass": 84893,
	"./themes/nova/pages/NovaDashboard": 26873,
	"./themes/nova/pages/NovaDashboard.jsx": 26873,
	"./themes/nova/pages/NovaDashboard.module.sass": 66410,
	"./themes/nova/pages/NovaMailbox": 1687,
	"./themes/nova/pages/NovaMailbox.jsx": 1687,
	"./themes/nova/pages/NovaMailbox.module.sass": 52710,
	"./themes/nova/pages/NovaSettings": 20919,
	"./themes/nova/pages/NovaSettings.jsx": 20919,
	"./themes/nova/pages/NovaSettings.module.sass": 34425,
	"./themes/nova/pages/NovaTrading": 73170,
	"./themes/nova/pages/NovaTrading.jsx": 73170,
	"./themes/nova/pages/NovaTrading.module.sass": 28925,
	"./themes/nova/pages/NovaWallet": 53412,
	"./themes/nova/pages/NovaWallet.jsx": 53412,
	"./themes/nova/pages/NovaWallet.module.sass": 17201,
	"./themes/nova/pages/NovaWithdrawPanel": 92721,
	"./themes/nova/pages/NovaWithdrawPanel.jsx": 92721,
	"./themes/nova/pages/NovaWithdrawPanel.module.sass": 35590,
	"./themes/nova/useFitGrid": 23022,
	"./themes/nova/useFitGrid.js": 23022,
	"./themes/nova/useNovaPortfolio": 81251,
	"./themes/nova/useNovaPortfolio.js": 81251,
	"./utils/amountGenerator": 66471,
	"./utils/amountGenerator.js": 66471,
	"./utils/audit": 53449,
	"./utils/audit.js": 53449,
	"./utils/configFlagCache": 47432,
	"./utils/configFlagCache.js": 47432,
	"./utils/configUtils": 78185,
	"./utils/configUtils.js": 78185,
	"./utils/confirmDialog": 93102,
	"./utils/confirmDialog.js": 93102,
	"./utils/consoleBlocker": 80737,
	"./utils/consoleBlocker.js": 80737,
	"./utils/countryNames": 9742,
	"./utils/countryNames.js": 9742,
	"./utils/dynamicLoader": 88772,
	"./utils/dynamicLoader.js": 88772,
	"./utils/flagUtils": 99501,
	"./utils/flagUtils.js": 99501,
	"./utils/fontLoader": 9170,
	"./utils/fontLoader.js": 9170,
	"./utils/frontendDeterrents": 80354,
	"./utils/frontendDeterrents.js": 80354,
	"./utils/globalInteractionAudit": 2680,
	"./utils/globalInteractionAudit.js": 2680,
	"./utils/notify": 88133,
	"./utils/notify.js": 88133,
	"./utils/permissions": 21298,
	"./utils/permissions.js": 21298,
	"./utils/plural": 27550,
	"./utils/plural.js": 27550,
	"./utils/userUtils": 48922,
	"./utils/userUtils.js": 48922,
	"./utils/walletResolver": 23775,
	"./utils/walletResolver.js": 23775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;